// Copyright (c) Microsoft. All rights reserved.

import { AnyAction, combineReducers, createAction, Reducer } from '@reduxjs/toolkit';
import appReducer from '../features/app/appSlice';
import conversationsReducer from '../features/conversations/conversationsSlice';
import conversationsReducer_v2 from '../features/conversations/conversationsSlice_v2';
import usersReducer from '../features/users/usersSlice';
import aiModelReducer from '../features/app/aiModelsSlice';
import pluginReducer from '../features/app/pluginsSlice';
import categoryReducer from '../features/studio/categorySlice';
import pluginStudioReducer from '../features/studio/pluginStudioSlice';
import toolReducer from '../features/app/toolSlice';

import { RootState } from './store';

// Define a top-level root state reset action
export const resetApp = createAction('resetApp');

// Define a root reducer that combines all the reducers
const rootReducer: Reducer<RootState> = combineReducers({
  app: appReducer,
  conversations: conversationsReducer,
  conversations_v2: conversationsReducer_v2,
  users: usersReducer,
  models: aiModelReducer,
  plugins: pluginReducer,
  category: categoryReducer,
  pluginStudio: pluginStudioReducer,
  tools: toolReducer
});

// Define a special resetApp reducer that handles resetting the entire state
export const resetAppReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === resetApp.type) {
    state = {
      // Explicitly call each individual reducer with undefined state.
      // This allows the reducers to handle the reset logic and return the initial state with the correct type.
      app: appReducer(undefined, action),
      conversations: conversationsReducer(undefined, action),
      conversations_v2: conversationsReducer_v2(undefined, action),
      users: usersReducer(undefined, action),
      models: aiModelReducer(undefined, action),
      plugins: pluginReducer(undefined, action),
      category: categoryReducer(undefined, action),
      pluginStudio: pluginStudioReducer(undefined, action),
      tools: toolReducer(undefined, action)
    };
  }

  return rootReducer(state, action);
};

export default resetAppReducer;
